var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileDemoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1017 17.9741C5.94482 17.9741 1.54102 18.7538 1.54102 21.8763C1.54102 24.9989 5.91689 25.8065 11.1017 25.8065C16.2585 25.8065 20.661 25.0255 20.661 21.9043C20.661 18.783 16.2864 17.9741 11.1017 17.9741Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1019 13.5204C14.486 13.5204 17.2289 10.7762 17.2289 7.39212C17.2289 4.00799 14.486 1.26514 11.1019 1.26514C7.7178 1.26514 4.97367 4.00799 4.97367 7.39212C4.96224 10.7648 7.68732 13.5089 11.0587 13.5204H11.1019Z",
    stroke: "#2A38A4",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDemoIcon);
export default __webpack_public_path__ + "static/media/profileDemoIcon.1d59a518913525d12891c61a236188fe.svg";
export { ForwardRef as ReactComponent };